require('./mortgageRequestHolderConfirmation.scss');

// @vendor
const { formatText, FormattedText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKMessage } = require('commonsComponents/OKMessage');
const getExtension = require('utilities/mimeTypeToExt');

// @components
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;

// @actions
const getHolderConfirmActions = require('actions/mortgageRequest/mortgageRequestHolderConfirmation');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const mortgageRequestWorkDataActions = require('actions/mortgageRequest/mortgageRequestWorkData');
const mortgageRequestConditionsActions = require('actions/mortgageRequest/mortgageRequestConditions');


// @constants
const { MORTGAGE_REQUEST_CONFIRM_HOLDER_DATA } = require('constants/operationTypes');
const { COMMONS } = require('constants/mortgageRequestHolderData');
const FILENAMES = require('constants/mortgageRequestFileNames');
const EXTENSIONS = require('constants/mimeTypesExtensions.js');
const { NOT_ALLOWED_EVIDENCE_CIRBE_MORTGAGE_COUNTRIES } = require('constants/flagBasedFeatures');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @helpers
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const BrowserUtils = require('utilities/browserUtils');


class MortgageRequestHolderConfirmation extends React.Component {
    constructor(props) {
        super(props);

        const { immHolderConfirmState } = this.props;

        this.state = {
            id: immHolderConfirmState.get('id'),
            confirm: false,
            acceptCaser: false,
            confirmValid: false,
            loading: immHolderConfirmState.get('isFetching'),
            scrollDown: immHolderConfirmState.get('scrollDown'),
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);

    }

    componentDidMount() {
        const {getHolderData,mortgageRequestConditions,requestConditions, requestDataProprietor, checkHolderPersonalInfo, dataProprietors, requestMortgageHolderConfirmationInit, requestMortgageRequestHolderConfirmDocumentsCirbe, userIdentification, immHolderConfirmState } = this.props;
        requestDataProprietor();
        checkHolderPersonalInfo();
        const checkUserIdentification = userIdentification.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const personalData = dataProprietors.get('personalData');
        const currentUser = personalData.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
        const conditions = mortgageRequestConditions.get('conditions');
        if(!currentUser || !conditions){
            requestConditions()
            getHolderData(userIdentification)
            return
        }
        if (immHolderConfirmState.get('completeHoldersData') && currentUser?.operationProcessId === "") {
            requestMortgageHolderConfirmationInit();
        } else if (currentUser?.operationProcessId !== "") {
            requestMortgageRequestHolderConfirmDocumentsCirbe(currentUser.operationProcessId);
        }
    }

    componentWillUnmount() {
        const { cleanDocumentsState } = this.props;

        cleanDocumentsState();
    }

    componentDidUpdate(prevProps) {
        const {mortgageRequestConditions, dataProprietors, requestMortgageHolderConfirmationInit, requestMortgageRequestHolderConfirmDocumentsCirbe, userIdentification, immHolderConfirmState } = this.props;
        const checkUserIdentification = userIdentification.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const personalData = dataProprietors.get('personalData');
        const personalDataPrev = prevProps.dataProprietors.get('personalData');
        const currentUser = personalData.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
        const currentUserPrev = personalDataPrev.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
        const conditions = mortgageRequestConditions.get('conditions');

        if (!currentUserPrev && currentUser  && conditions ){
            if (immHolderConfirmState.get('completeHoldersData') && currentUser?.checkCirbe !== 1 && currentUser?.operationProcessId === "") {
                requestMortgageHolderConfirmationInit();
            }    
             else if (!(currentUser?.operationProcessId === "")) {
                requestMortgageRequestHolderConfirmDocumentsCirbe(currentUser.operationProcessId);
            }
        }
    }




    
    handleDocumentReaded() {
        const { confimationScrollDown } = this.props;
        confimationScrollDown();
    }

    handleDownloadPdf() {
        const { immHolderConfirmState } = this.props;
        if (immHolderConfirmState.get('documentCirbe')) {
            const base64  = immHolderConfirmState.get('documentCirbe');
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const fileName = `${FILENAMES.SOL_PRE}.${getExtension(contentType)}`;
            downloadAsFile(base64ToBlob(pdf), contentType, fileName);
        }
    }

    handleOnPrint() {
        const { immHolderConfirmState } = this.props;
        if (immHolderConfirmState.get('documentCirbe')) {
            const base64  = immHolderConfirmState.get('documentCirbe');
            const contentType = "application/pdf";
            const fileName = `${FILENAMES.SOL_PRE}.${EXTENSIONS[contentType]}`;
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });

            if (BrowserUtils.browserIsIE()) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {
                const blobURL = URL.createObjectURL(blobObject);
                const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
                const printWindow = window.open(blobURL, '', winparams);
                if (printWindow) {
                    printWindow.print();
                }
            }
        }
    }
    buildViewerErr() {

        const { requestDocuments } = this.props

        const title = formatText(`mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_PDFTitle`);
        const pdfErr = <FormattedText className="mortgage-request-holder-confirmation__txt-err" value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_pdfErr" />;
        const button = (
            <OKButton modifier="secondary" size="small" onClick={requestDocuments}>
                <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_reloadButton" />
            </OKButton>
        );

        return (
            <div className="mortgage-request-holder-confirmation">
                <div className="mortgage-request-holder-confirmation__doc-err-header">{title}</div>
                <div className="mortgage-request-holder-confirmation__doc-err">
                    <EmptyState
                        secondaryText={pdfErr}
                        button={button}
                        iconType="noitems-banking"
                    />
                </div>
                <div className="mortgage-request-holder-confirmation__content-err">
                    <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_pdfErr2" />
                </div>
            </div>
        );
    }
    buildViewer() {
        const { immHolderConfirmState, dataProprietors, userIdentification } = this.props;
        const personalData = dataProprietors.get('personalData');
        const isCheckedCirbe = personalData.some(person => person?.checkCirbe === 1);
        const checkUserIdentification = userIdentification.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const currentUser = personalData.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
        if (!immHolderConfirmState.get('completeHoldersData')) {
            return null;
        }

        if (immHolderConfirmState.get('documentCirbe')) {
            let title;
            if (isCheckedCirbe || currentUser?.operationProcessId !== "") {
                title = formatText(`mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_PDFTitle_CheckedCirbe`);
            } else {
                title = formatText(`mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_PDFTitle`);
            }
            const scale = 1.05;
            const viewerHeight = 280;
            const base64 = immHolderConfirmState.get('documentCirbe');
            const contentType = "application/pdf";
            const docLink = `data:${contentType};base64,${base64}`;

            return (
                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={docLink}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            );
        } else {
            return <LoadingSection />;
        }
    }

    handleCheckboxChange(event) {
        if (event.target.id === 'confirm') {
            this.setState({ confirm: event.target.checked });
        } else {
            this.setState({ acceptCaser: event.target.checked });
        }
    }

    handleSave(event) {
        event && event.preventDefault();
        const { editHolderConfirm, isClientWithoutAccounts, history } = this.props;
        const valid = this.validateFields();
        if (valid) {
            editHolderConfirm(this.state.acceptCaser, isClientWithoutAccounts, history);
        }
    }

    validateFields() {
        let valid = true;
        //Form validations
        if (!this.state.confirm) {
            this.setState({ confirmValid: true });
            valid = false;
        } else {
            this.setState({ confirmValid: false });
        }
        return valid;
    }

    buildGdprContent() {
        const { isClientWithoutAccounts, immFeatureFlag, dataProprietors, immHolderConfirmState, userIdentification } = this.props;
        let gdprContent;
        if (!isClientWithoutAccounts && this.state.confirm) {
            const isOnFeatureFlag = immFeatureFlag.get(NOT_ALLOWED_EVIDENCE_CIRBE_MORTGAGE_COUNTRIES);
            const checkUserIdentification = userIdentification.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
            const personalData = dataProprietors.get('personalData');
            const currentUser = personalData.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
            let operationProcessId = '';
            if (currentUser?.checkCirbe !== 1 && currentUser?.operationProcessId === "") {
                const operationProcesses = immHolderConfirmState.get('operationProcesses').toJS();
                const operationProcess = operationProcesses.find(process => process.documentNumber === checkUserIdentification);
                operationProcessId = operationProcess ? operationProcess.operationProcessId : '';
            } else if (currentUser?.operationProcessId !== "") {
                operationProcessId = currentUser.operationProcessId;
            }            
            gdprContent = (
                <div className="mortgage-request-holder-confirmation__gdpr">
                    <SignaturePattern
                        operationType={MORTGAGE_REQUEST_CONFIRM_HOLDER_DATA}
                        operationParams={
                            isOnFeatureFlag 
                            ? {
                                evidenceType: 'SIGN_DOCUMENT',
                                operationProcessId: operationProcessId,
                            } 
                            : {}
                        }
                    />
                </div>
            );
        }

        return gdprContent;
    }

    subtitleLink() {
        const { immHolderConfirmState, dataProprietors, userIdentification } = this.props;
        const personalData = dataProprietors.get('personalData');
        const isCheckedCirbe = personalData.some(person => person?.checkCirbe === 1);
        const checkUserIdentification = userIdentification.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const currentUser = personalData.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
        let subtitleLink;

        if (isCheckedCirbe || currentUser?.operationProcessId !== "") {
            subtitleLink = (
                <OKMessage type="informative">
                    <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_Text_CheckedCirbe" />
                </OKMessage>
            );
        } else {
            subtitleLink = (
                <React.Fragment>
                    <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_subtitle1" />
                    <OKLink to={'/myprofile/mortgage/panel'} extraClass="mortgage-request-holder-confirmation__back-link" modifier="emphasize">
                        <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_subtitleLink" />
                    </OKLink>
                </React.Fragment>
            );
        }

        if (!immHolderConfirmState.get('completeHoldersData')) {
            subtitleLink = (
                <OKMessage type="informative">
                    <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_subtitleCompleteDataInfo" />
                    <OKLink to={'/myprofile/mortgage/panel'} modifier="emphasize">
                        <FormattedText format="firstUppercase" value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_subtitleCompleteDataLink" />
                    </OKLink>
                    <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_subtitleCompleteData" />
                </OKMessage>
            );
        }

        return subtitleLink;
    }

    buildTitle() {

        const { isClientWithoutAccounts } = this.props;

        let content;

        if (isClientWithoutAccounts) {
            content = <FormattedText value="mortgageRequestHolderConfirmation-subtitle" />;
        } else {
            content = <FormattedText value="mortgageRequestHolderConfirmation-mortgageRequestHolderConfirmation_subtitleClient" />;
        }
        return content;
    }


    buildCurrentButton() {

        const { isClientWithoutAccounts, immHolderConfirmState, disbledButtonOffice } = this.props;

        let disabledRadionAndButton = false;
        const officeDisabledButton = disbledButtonOffice.get('disbledButtonOffice');

        if (!immHolderConfirmState.get('completeHoldersData') || !this.state.confirm) {
            disabledRadionAndButton = true;
        }

        const textButton = <FormattedText className="mortgage-request-holder-confirmation__button-signature" value="mortgageRequestHolderConfirmation-save" />;
        const SignatureButtonProps = {
            onClick: this.handleSave,
            loading: immHolderConfirmState.get('isFetching'),
            disabled: disabledRadionAndButton || isPrintOfficeMode() && officeDisabledButton,
        };

        let content;

        if (isClientWithoutAccounts) {
            content = <OKButton {...SignatureButtonProps}> {textButton} </OKButton>;
        } else {
            content = <SignaturePatternButton {...SignatureButtonProps}> {textButton} </SignaturePatternButton>;
        }
        return content;
    }

    buildConfirmationMessageKey() {

        const { isClientWithoutAccounts, dataProprietors } = this.props;
        const totalUserInCharge = dataProprietors.get('data').toJS().length;
        let confirmationMessageKey;

        if (isClientWithoutAccounts) {
            confirmationMessageKey = 'mortgageRequestHolderConfirmation_confirmationCheckTextNoClient';
        } else {
            confirmationMessageKey = totalUserInCharge > 1 ? 'mortgageRequestHolderConfirmation_confirmationCheckText2' : 'mortgageRequestHolderConfirmation_confirmationCheckText';
        }
        return confirmationMessageKey;
    }

    render() {
        const { holderConfirmDocuments, immHolderConfirmState, dataProprietors, userIdentification, isClientWithoutAccounts } = this.props;
        const checkUserIdentification = userIdentification.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const backText = formatText('mortgageRequestHolderConfirmation-back');
        const addDefaultError = formatText('mortgageRequestCommons-defaultFormError');
        let disabledRadionAndButton = false;
        const personalData = dataProprietors.get('personalData');
        const currentUser = personalData.find(person => person?.documentoDeIdentidad?.identificador === checkUserIdentification);
        const isCheckedCirbe = currentUser?.checkCirbe === 0;
        const isOperationProcessIdEmpty = currentUser?.operationProcessId === "";
        if (!immHolderConfirmState.get('completeHoldersData') || !isCheckedCirbe || isClientWithoutAccounts && !isOperationProcessIdEmpty) {
            disabledRadionAndButton = true;
        }
        const pdfError = holderConfirmDocuments.get('error');
        const PDFLinks = pdfError ? this.buildViewerErr() : this.buildViewer();
        const confirmationMessageKey = this.buildConfirmationMessageKey();

        const OKCheckboxProps = {
            idName: 'confirm',
            label: <FormattedText value={`mortgageRequestHolderConfirmation-${confirmationMessageKey}`} />,
            onChange: this.handleCheckboxChange,
            value: disabledRadionAndButton ? true : this.state.confirm || false,
            errorState: this.state.confirmValid,
            errorMessage: addDefaultError,
            disabled: disabledRadionAndButton
        };

        const gdprContent = this.buildGdprContent();
        const CurrentButton = this.buildCurrentButton();
        const subtitleLink = this.subtitleLink();
        const title = this.buildTitle();

        return (
            <ContentBox customClassName="mortgage-request-holder-confirmation">
                <div className="mortgage-request-holder-confirmation__title">
                    {title}
                </div>
                <div className="mortgage-request-holder-confirmation__subtitle">
                    {subtitleLink}
                </div>
                <div className="mortgage-request-holder-confirmation__document-link">
                    {PDFLinks}
                </div>
                <div className="mortgage-request-holder-confirmation__checkbox">
                    {!pdfError && <OKCheckbox {...OKCheckboxProps} />}
                </div>
                <div className="mortgage-request-holder-confirmation__disclaimer">
                    <FormattedText
                        value="mortgageRequestHolderConfirmation-confirmationMessageDescription2"
                        injectedStrings={[COMMONS.MORTGAGE_HOLDER_INCIDENCIAS_PHONE]}
                    />
                </div>
                {gdprContent}
                <div className="mortgage-request-holder-confirmation__footer">
                    <div className="pull-left">
                        <OKLink to={'/myprofile/mortgage/panel'}>
                            {backText}
                        </OKLink>
                    </div>
                    {CurrentButton}
                </div>
            </ContentBox >
        );
    }
}

MortgageRequestHolderConfirmation.propTypes = {
    mortgageRequestState: PropTypes.object,
    holderConfirmDocuments: PropTypes.object,
    immHolderConfirmState: PropTypes.object,
    dataProprietors: PropTypes.object,
    requestDataProprietor: PropTypes.func,
    requestConditions: PropTypes.func,
    getHolderData: PropTypes.func,
    requestDocuments: PropTypes.func,
    editHolderConfirm: PropTypes.func,
    cleanDocumentsState: PropTypes.func,
    checkHolderPersonalInfo: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MortgageRequestHolderConfirmation;

module.exports.MortgageRequestHolderConfirmation = withRouter(connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        holderConfirmDocuments: state.mortgageRequestHolderConfirmDocuments,
        dataProprietors: state.mortgageRequestDataProprietor,
        immHolderConfirmState: state.mortgageRequestHolderConfirmEdit,
        userIdentification: state.profile,
        immFeatureFlag: state.flagBasedFeatures,
        disbledButtonOffice: state.mortgageRequestHolderConfirmEdit,
        mortgageRequestConditions: state.mortgageRequestConditions,

    }),
    {
        getHolderData: mortgageRequestWorkDataActions.getHolderData,
        requestConditions: mortgageRequestConditionsActions.requestConditions,
        requestDocuments: getHolderConfirmActions.requestDocuments,
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
        editHolderConfirm: getHolderConfirmActions.editHolderConfirm,
        cleanDocumentsState: getHolderConfirmActions.cleanDocumentsState,
        checkHolderPersonalInfo: getHolderConfirmActions.holderCheckPersonalInfo,
        requestMortgageHolderConfirmationInit: getHolderConfirmActions.requestMortgageHolderConfirmationInit,
        requestMortgageRequestHolderConfirmDocumentsCirbe: getHolderConfirmActions.requestMortgageRequestHolderConfirmDocumentsCirbe,
        confimationScrollDown: getHolderConfirmActions.confimationScrollDown,
    }
)(MortgageRequestHolderConfirmation));
